import { defineWave } from '../schema';

/** BOSS — L'ARRIVÉE DU COLOSSE. Dernier combat de la campagne.
 *
 *  ── Six secondes de silence, et non cinq ──
 *  Le haut de la fourchette du plan (§6.6). Les deux boss précédents en ont
 *  cinq ; l'écart d'une seconde est perceptible sans être identifiable, ce qui
 *  est exactement l'effet recherché — le joueur sent que ce silence-ci dure
 *  plus longtemps que ceux qu'il connaît, sans savoir dire pourquoi.
 *
 *  ── Couloir 3 ──
 *  Le centre, pour les mêmes raisons qu'aux deux mondes précédents. Le
 *  balancement du Colosse ne veut rien dire tant que le joueur ne l'a pas
 *  d'abord vu immobile au milieu, et sa silhouette asymétrique — deux ailes, un
 *  dôme seul au sommet — ne se lit que de face.
 *
 *  ⚠️ 120 s, très au-delà des 50 à 70 s attendus. `levelSystem` ne sait pas
 *  qu'un boss est mort, il ne connaît que des horloges : une durée trop courte
 *  ne raccourcirait pas le combat, elle ferait démarrer le bloc suivant
 *  par-dessus. Ici il n'y a pas de bloc suivant — mais la durée déclarée sert
 *  aussi de garde-fou à `validate()`, et un chiffre juste vaut mieux qu'un
 *  chiffre qui se trouve ne pas nuire. */
export default defineWave({
  id: 'boss-colosse',
  duration: 120,
  spawns: [{ at: 6.0, enemy: 'colosse', lane: 3, count: 1, spacing: 0 }],
});
